import { render, staticRenderFns } from "./UploadBankStatement.vue?vue&type=template&id=015b8447&scoped=true"
import script from "./UploadBankStatement.vue?vue&type=script&lang=js"
export * from "./UploadBankStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015b8447",
  null
  
)

export default component.exports